// import Products from '@/modules/promotions/promotion-products/index.vue';
import Banner from '@/modules/promotions/banner/index.vue'
// import Product from '@/modules/promotions/promotion-product/index.vue'
import {mapMutations, mapGetters, mapActions} from "vuex";

export default {
    name: 'promotions',
    components: {
        // Products,
        Banner,
        // Product
    },
    data() {
        return {
            isLoading: false,
            startDate: '',
            endDate: '',
            routeName: this.$route,
            payload: {skip: 1}
        }
    },
    created() {

        this.resetSkip()
        // this.fetchPromoList({skip:this.payload.skip})
        // this.getDateActions()
    },
    watch: {
        '$route'() {
            this.resetSkip()
        },
    },
    computed: {
        ...mapGetters({
            getList: `promotions/getList`,
            getCurrentList: 'promotions/getCurrentList',
            getProductsLength: 'promotions/getProductsLength',
        }),
    },
    methods: {
        ...mapActions({
            fetchPromoList: `promotions/GET_PROMOTIONS_LIST`,
            fetchNewPromoList: `promotions/GET_PROMOTIONS_CURRENT_LIST`,
        }),
        ...mapMutations({
            resetSkip: `promotions/RESET_SKIP`,
            resetLimit:`promotions/RESET_LIMIT`
        }),
        mounted() {
            if (localStorage.startDate && localStorage.endDate) {
                this.startDate = localStorage.startDate;
                this.endDate = localStorage.endDate;
            }
        },
        getDateActions() {
            if (this.getList !== null) {
                this.getList.forEach(el => {
                    this.startDate = el.start_date
                    this.endDate = el.end_date
                })
            }
        }

    }
}
